// Auto-generated build information - do not edit manually
// Generated at: 2026-10-14T13:25:27.150Z

export const buildInfo = {
  "buildNumber": "220-dev1791984327150",
  "buildDate": "2026-10-14T13:25:27.150Z",
  "gitCommit": "1ed3ade",
  "gitBranch": "dev",
  "gitTag": null,
  "environment": "dev"
} as const;

export type BuildInfo = typeof buildInfo;
